import { Container } from 'ui';
import { Dialog, DialogContent, DialogHeading, Typography } from 'omakase';
import { Theme, css } from '@emotion/react';
import { useActions } from '@tock/shared/utils/connect';
import React from 'react';

const dialogContentDisplayDef = ({ spacing }: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(1)}px;
`;

const verifiyEmailHeaderDef = ({ spacing }: Theme) => css`
  padding-top: ${spacing(1)}px;
`;

const dialogTextBodyDef = ({ spacing }: Theme) => css`
  max-width: 340px;
  text-align: center;
  padding-top: ${spacing(1)}px;
`;

const resendEmailLinkDef = ({ spacing }: Theme) => css`
  cursor: pointer;
  padding-top: ${spacing(2)}px;
  padding-bottom: ${spacing(5)}px;
`;

interface Props {
  isOpen: boolean;
  onClose(): void;
  email: string;
}

const VerifyEmailDialog: React.FunctionComponent<Props> = ({ isOpen, onClose, email }) => {
  const { actions } = useActions();

  const handleResendConfirmation = () => {
    actions.app.resendVerificationEmail(email);
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogHeading onClose={onClose}>Finish Tock account setup</DialogHeading>
      <DialogContent>
        <Container css={dialogContentDisplayDef}>
          <Typography css={verifiyEmailHeaderDef} variant="heading04" component="h2">
            Verify your email address
          </Typography>
          <Typography css={dialogTextBodyDef}>
            To finish setting up your account, please click on the link in the email we sent you.
          </Typography>
          <Typography
            css={resendEmailLinkDef}
            color="fgPrimaryBase"
            onClick={handleResendConfirmation}
          >
            Resend email
          </Typography>
        </Container>
      </DialogContent>
    </Dialog>
  );
};

export default VerifyEmailDialog;
